import React, { useEffect, useState } from "react";
import { getUser } from "../../auth";
import UpdateStockForm from "../components/UpdateStockForm";

const URL = process.env.REACT_APP_API_URL;

export default function UpdateStock({ open, close }) {
  const [stocks, setStocks] = useState([]);
  const [quantities, setQuantities] = useState({});
  const [message, setMessage] = useState("");
  const user = getUser();

  useEffect(() => {
    if (!open) return;

    const fetchStocks = async () => {
      try {
        const res = await fetch(`${URL}/api/stock/?empresa_id=${user.empresa_id}`);
        if (!res.ok) throw new Error("Error fetching stocks");
        const data = await res.json();
        setStocks(data);
      } catch (error) {
        console.error("Error fetching stocks:", error);
        setMessage("Error al obtener los stocks.");
      }
    };

    fetchStocks();
  }, [open, user.empresa_id]);

  const handleQuantityChange = (stockId, value) => {
    setQuantities((prev) => ({
      ...prev,
      [stockId]: Number(value)
    }));
  }

  const handleReset = () => {
    setQuantities({});
    setMessage("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const items = stocks
      .map(stock => ({
        product_id: stock.product_id,
        quantity: quantities[stock.id] || 0
      }))
      .filter(item => item.quantity > 0);
    
    if (items.length === 0) {
      setMessage("Debe ingresar una cantidad válida para al menos un stock.")
      return;
    }

    try {
      await fetch(`${URL}/api/stock/bulk-update`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-Empresa-Id": user.empresa_id,
        },
        body: JSON.stringify({
          products: items 
        }),
      });

      setMessage("Stock actualizado correctamente.");
      handleReset();
      close();
    } catch (error) {
      setMessage("Error al actualizar el stock.");
    }
  };

  return (
    <UpdateStockForm
      open={open}
      onClose={close}
      onSubmit={handleSubmit}
      onReset={handleReset}
      stocks={stocks}
      quantities={quantities}
      handleQuantityChange={handleQuantityChange}
      message={message}
    />
      
  )
}